import { createContext, useContext, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const DIRECTIONS = {
  LTR: 'ltr',
  RTL: 'rtl'
};
const DirectionContext = /*#__PURE__*/createContext(null);
const DirectionProvider = ({
  direction: initialDirection = DIRECTIONS.LTR,
  ...props
}) => {
  const [direction, setDirection] = useState(initialDirection);
  const setDirectionContext = newDirection => setDirection(newDirection);
  const isRTL = direction === DIRECTIONS.RTL;
  return /*#__PURE__*/_jsx(DirectionContext.Provider, {
    value: {
      direction,
      isRTL,
      setDirectionContext
    },
    ...props
  });
};
const useDirection = () => {
  const context = useContext(DirectionContext);
  if (!context) {
    throw new Error('useDirection must be used within a DirectionProvider');
  }
  return {
    ...context,
    isRTL: context.direction === DIRECTIONS.RTL
  };
};
export { DIRECTIONS, DirectionProvider, useDirection };
//# sourceMappingURL=DirectionContext.js.map